import PocketBase from "pocketbase";

export const pb = new PocketBase("http://127.0.0.1:8090");

// Test connection and collections
export const testPocketBaseConnection = async () => {
  try {
    // Test basic connection
    await pb.health.check();
    console.log("✅ PocketBase connection successful");

    // Test if users collection exists by trying to create a test record
    try {
      await pb.collection("users").create({
        email: "test@example.com",
        password: "123456",
        passwordConfirm: "123456",
        name: "Test User",
      });
      // If successful, delete the test record
      const testUser = await pb
        .collection("users")
        .getFirstListItem('email = "test@example.com"');
      await pb.collection("users").delete(testUser.id);

      return {
        success: true,
        missingCollections: [],
        message: "✅ PocketBase is running and users collection is working!",
      };
    } catch (error: any) {
      if (error.status === 404) {
        return {
          success: true,
          missingCollections: [
            "users",
            "transactions",
            "assets",
            "incomeSources",
            "debts",
            "partners",
          ],
          message:
            "✅ PocketBase is running! Collections need to be created manually in the admin panel.",
        };
      } else {
        return {
          success: true,
          missingCollections: [
            "users",
            "transactions",
            "assets",
            "incomeSources",
            "debts",
            "partners",
          ],
          message:
            "✅ PocketBase is running! Collections need to be created manually in the admin panel.",
        };
      }
    }
  } catch (error: any) {
    console.error("❌ PocketBase connection failed:", error);

    // Provide more specific error messages
    if (error.message?.includes("fetch")) {
      return {
        success: false,
        error: {
          message:
            "Cannot connect to PocketBase. Make sure it's running on http://127.0.0.1:8090",
        },
        message: "PocketBase is not running. Start it with: ./pocketbase serve",
      };
    } else if (error.message?.includes("timeout")) {
      return {
        success: false,
        error: {
          message: "Connection timeout. PocketBase might be starting up.",
        },
        message: "Please wait a moment and try again.",
      };
    } else {
      return {
        success: false,
        error: { message: error.message || "Something went wrong" },
        message: "Check that PocketBase is running and accessible.",
      };
    }
  }
};

// Enable real-time subscriptions for collections with better error handling
const setupRealtimeSubscriptions = () => {
  const collections = [
    "users",
    "transactions",
    "assets",
    "incomeSources",
    "debts",
    "partners",
  ];

  collections.forEach((collectionName) => {
    try {
      pb.collection(collectionName).subscribe(
        "*",
        function (e) {
          console.log(`${collectionName} collection changed:`, e);
        },
        function (error: any) {
          // Only log the error once to avoid spam
          if (!error.logged) {
            console.warn(
              `⚠️ Realtime subscription failed for ${collectionName}:`,
              error
            );
            error.logged = true;
          }
        }
      );
    } catch (error) {
      console.warn(
        `⚠️ Could not setup realtime subscription for ${collectionName}:`,
        error
      );
    }
  });
};

// Only setup realtime subscriptions if PocketBase is running
testPocketBaseConnection().then((result) => {
  if (result.success) {
    setupRealtimeSubscriptions();
  } else {
    console.warn("⚠️ PocketBase not ready, skipping realtime subscriptions");
  }
});
